module.exports = __webpack_public_path__ + "static/media/CupoPhoto.12cee95d.svg";